import * as Yup from "yup";
import setupYupExtensions from "./YupExtensions";
setupYupExtensions();

export const SignUpSchema = Yup.object().shape({
  email: Yup.string().email("Invalid email").required("Email is required"),
  password: Yup.string()
    .min(8)
    .max(255)
    .minNumbers(1)
    .minSymbols(1)
    .required("Password is required"),
});

export const LoginSchema = Yup.object().shape({
  email: Yup.string().email("Invalid email").required("Email is required"),
  password: Yup.string().max(255).required("Password is required"),
});

export const CreateSailorSchema = Yup.object().shape({
  email: Yup.string().email("Invalid email").required("Email is required"),
  firstName: Yup.string().min(1).max(255).required("First name is required"),
  lastName: Yup.string().min(1).max(255).required("Last name is required"),
});

export const CreateDealerSchema = Yup.object().shape({
  companyName: Yup.string().required("Company Name is required"),
  companyNumber: Yup.string().required("Company Number is required"),
  contactName: Yup.string().required("Contact Name is required"),
  contactNumber: Yup.string().required("Contact Number is required"),
  email: Yup.string().email("Invalid email").required("Email is required"),
  address1: Yup.string().min(1).max(255).required("Address1 is required"),
  city: Yup.string().required("City is required"),
  postcode: Yup.string().required("Postcode is required"),
});

export const CreateUserSchema = Yup.object().shape({
  email: Yup.string().email("Invalid email").required("Email is required"),
  firstName: Yup.string().min(1).max(255).required("First name is required"),
  lastName: Yup.string().min(1).max(255).required("Last name is required"),
  userType: Yup.string()
    .required("Please select a user type")
    .oneOf(["admin", "dealer", "sailor"]),
});

export const EditApplicationSchema = Yup.object().shape({
  email: Yup.string().email("Invalid email").required("Email is required"),
  firstName: Yup.string().min(1).max(255).required("First name is required"),
  lastName: Yup.string().min(1).max(255).required("Last name is required"),
  userType: Yup.string()
    .required("Please select a user type")
    .oneOf(["admin", "dealer", "sailor"]),
});

export const ActionSchema = Yup.object().shape({
  actionFor: Yup.string().optional(),
  note: Yup.string().max(200).default(""),
  state: Yup.string().required("Action state is required"),
});
